import { render, staticRenderFns } from "./BloqueEventos.vue?vue&type=template&id=1c37fe6e"
import script from "./BloqueEventos.vue?vue&type=script&lang=js"
export * from "./BloqueEventos.vue?vue&type=script&lang=js"
import style0 from "./BloqueEventos.vue?vue&type=style&index=0&id=1c37fe6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports